import { render, staticRenderFns } from "./TabCapitulosEspeciales.vue?vue&type=template&id=1420b0a9"
import script from "./TabCapitulosEspeciales.vue?vue&type=script&lang=js"
export * from "./TabCapitulosEspeciales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1420b0a9')) {
      api.createRecord('1420b0a9', component.options)
    } else {
      api.reload('1420b0a9', component.options)
    }
    module.hot.accept("./TabCapitulosEspeciales.vue?vue&type=template&id=1420b0a9", function () {
      api.rerender('1420b0a9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/staff/tasks/validaciones/constitucionsociedades/TabCapitulosEspeciales.vue"
export default component.exports